import type { ElMessageBoxOptions } from 'element-plus'
import { ElMessageBox } from 'element-plus'

export async function messageBoxConfirm({
  message = '确定执行此操作吗',
  title = '提醒',
  type = '',
  center = false,
  dangerouslyUseHTMLString = false,
  ...rest
}: ElMessageBoxOptions) {
  return ElMessageBox.confirm('', {
    message,
    title,
    center,
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type,
    dangerouslyUseHTMLString,
    ...rest,
  })
}
